import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  HostBinding,
  input,
  signal,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { pickColorForName } from './color-generator';

@Component({
  selector: 'glxy-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  imports: [MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.color]': 'textColor()',
    '[style.width.px]': 'width()',
    '[style.height.px]': 'width()',
    '[style.font-size.px]': 'width()',
    '[style.filter]': 'grayScaleValue()',
    '[style.border]': 'border()',
    '[class.shape-circle]': 'isCircle()',
    '[class.shape-square]': 'isSquare()',
  },
})
export class AvatarComponent {
  @HostBinding('class') class = 'glxy-avatar';

  protected defaultIcon = 'person';

  src = input<string | undefined>();
  svgIcon = input<string | undefined>();
  name = input<string | undefined>();
  width = input<number>(40);
  shape = input<'circle' | 'square'>('circle');
  icon = input<string | undefined>();
  abbreviation = input<string | undefined>();
  backgroundColor = input<string | undefined>();

  useGrayScale = input(false, { transform: booleanAttribute });
  textColor = input<string | undefined>();

  borderColor = input<string | undefined>();
  border = computed(() => {
    return this.borderColor() ? `1px solid ${this.borderColor()}` : 'none';
  });

  isCircle = computed(() => this.shape() === 'circle');
  isSquare = computed(() => this.shape() === 'square');
  grayScaleValue = computed(() => (this.useGrayScale() ? 'grayscale(100%)' : 'none'));
  computedBackgroundColor = computed(() => {
    if (this.computedBackgroundImageUrl()) {
      return;
    }

    if (this.backgroundColor()) {
      return this.backgroundColor();
    }
    return pickColorForName(this.name() || '');
  });
  computedAbbreviation = computed(() => {
    if (this.abbreviation()) {
      return this.abbreviation();
    }

    const inputName = this.name();
    if (inputName) {
      const names = inputName.trim().split(/\s+/);
      return names.length > 1 && this.width() > 24 ? names[0][0] + names[1][0] : names[0][0];
    }

    return;
  });

  computedBackgroundImageUrl = signal<string | undefined>(undefined);
  constructor() {
    effect(() => {
      const inputSrc = this.src();
      if (!inputSrc) {
        this.computedBackgroundImageUrl.set(undefined);
        return;
      }

      this.computedBackgroundImageUrl.set(`url(${inputSrc})`);
      const image = new Image();
      image.src = inputSrc;
      image.onerror = () => this.computedBackgroundImageUrl.set(undefined);
    });
  }
}
